export default {
    home_page_title: "Δεδομένα λογαριασμού",
    security_page_title: "Κέντρο ασφαλείας",
    security_setting_page_title: "Κέντρο ασφαλείας",
    security_phone_label: "Κινητό",
    security_email_label: "Email",
    security_question_label: "Ερωτήσεις ασφαλείας",
    security_unset_text: "Δεν έχετε ρυθμίσει",
    security_setted_text: "Έχετε ρυθμίσει",
    security_question_options: [
        "Το ονοματεπώνυμο της μητέρας σας είναι?",
        "Τα γενέθλια του συντρόφου σας είναι?",
        "Το ονοματεπώνυμο του πατέρα σας είναι?",
        "Ο αριθμός σπουδών ή εργασίας σας είναι?",
        "Ο καλύτερος παιδικός σας φίλος είναι?",
        "Το όν. του ατ. που σας έχει επηρ. περισσ. είναι?"
    ],
    password_lost_page_title: "Ξέχασα τον κωδικό",
    password_reset_page_title: "Επαναφορά κωδικού",
    password_lost_account_placeholder:
        "Εισάγετε τον λογαριασμό του κωδικού που ξεχάσατε",
    empty_lost_account_tips: "Το όνομα χρήστη δεν μπορεί να είναι κενό",
    iscorrect_lost_account_tips: "Ο χρήστης δεν υπάρχει",
    password_reset_new_placeholder: "Νέος κωδικός",
    password_reset_confirm_placeholder: "Επιβεβαίωση νέου κωδικού",
    password_verify_page_title: "Επαλήθευση ταυτότητας",
    phone_verify_page_title: "Επαλήθευση ταυτότητας",
    email_verify_page_title: "Επαλήθευση ταυτότητας",
    question_verify_page_title: "Επαλήθευση ταυτότητας",
    phone_reset_page_title: "Κινητό",
    email_reset_page_title: "Email",
    question_reset_page_title: "Ερωτήσεις ασφαλείας",
    phone_binding_text: "Το δεσμευμένο σας κινητό είναι",
    email_binding_text: "Το δεσμευμένο email σας είναι",
    verification_code_text: "Κωδικός επιβεβαίωσης",
    resend_text: "Στείλτε ξανά",
    empty_phone_number_tips: "Εισάγετε κινητό",
    iscorrect_phone_number_tips: "Παρακαλώ εισάγετε σωστή μορφή κινητού",
    empty_verification_code_tips: "Εισάγετε κωδικό επιβεβαίωσης",
    iscorrect_verification_code_tips: "Λάθος κωδικός επιβεβαίωσης",
    password_placeholder: "Κωδικός",
    empty_password_tips: "Εισάγετε κωδικό",
    iscorrect_password_tips: "Λάθος κωδικός",
    mismatched_rule_password_tips: "Ο κωδικός δεν μπορεί να περιέχει&,#, κενό",
    different_confirm_password_tips: "Οι κωδικοί δεν ταιριάζουν",
    empty_email_tips: "Εισάγετε email",
    iscorrect_email_tips: "Το email είναι λάθος",
    answer_placeholder: "Απάντηση",
    empty_question_tips: "Επιλέξτε ερώτηση ασφάλειας",
    empty_answer_tips: "Εισάγετε απάντηση,",
    iscorrect_answer_tips: "Λάθος απάντησης",
    next_step_text: "Επόμενο βήμα",
    submit_text: "Υποβολή",
    submit_success_tips: "Επιτυχία ρύθμισης",
    submit_error_tips: "Η λειτουργία απέτυχε, παρακαλώ προσπαθήστε ξανά",
    get_data_fail_tips: "Προβλημα δικτύου, παρακαλώ δοκιμάστε ξανά αργότερα",
    use_other_verification_type_text: "Άλλοι τρόποι επαλήθευσης",
    custom_support_notice:
        "Το παρόν λογάριασμό δεν έχει ρυθμίσει τρόποι ασφάλειας,μπορείτε μέσω pc να ανοίξετε το παρακάτω Link για να κάνετε την αίτηση" +
        process.env.VUE_APP_ORIGIN_PROFILE
};
